import script from "./CvTextInputSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CvTextInputSkeleton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__